export interface DsdEditorReviewLoadErrorPayload {
  createdAt: number;
}

const CHANNEL_NAME = "dsd-editor-review-load-error";
const STORAGE_KEY = "dsd-editor:review-load-error";

const isPayload = (
  value: unknown,
): value is DsdEditorReviewLoadErrorPayload => {
  if (!value || typeof value !== "object") return false;

  const record = value as Record<string, unknown>;
  return typeof record.createdAt === "number";
};

const parsePayload = (
  value: string | null,
): DsdEditorReviewLoadErrorPayload | null => {
  if (!value) return null;

  try {
    const parsed = JSON.parse(value);
    return isPayload(parsed) ? parsed : null;
  } catch {
    return null;
  }
};

export const publishDsdEditorReviewLoadError = () => {
  const payload: DsdEditorReviewLoadErrorPayload = {
    createdAt: Date.now(),
  };

  if (typeof BroadcastChannel !== "undefined") {
    const channel = new BroadcastChannel(CHANNEL_NAME);
    channel.postMessage(payload);
    channel.close();
    return;
  }

  localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
};

export const subscribeDsdEditorReviewLoadError = (
  listener: (payload: DsdEditorReviewLoadErrorPayload) => void,
) => {
  if (typeof BroadcastChannel !== "undefined") {
    const channel = new BroadcastChannel(CHANNEL_NAME);
    channel.onmessage = (event: MessageEvent<unknown>) => {
      if (isPayload(event.data)) listener(event.data);
    };

    return () => channel.close();
  }

  const handleStorage = (event: StorageEvent) => {
    if (event.key !== STORAGE_KEY) return;

    const payload = parsePayload(event.newValue);
    if (payload) listener(payload);
  };

  window.addEventListener("storage", handleStorage);

  return () => window.removeEventListener("storage", handleStorage);
};
